import { useMutation } from 'react-query';
import createRoomImages from '../requests/createRoomImages';

const useAddRoomImagesMutation = (options) =>
  useMutation(
    ({ descriptionId, files }) => createRoomImages(descriptionId, files),
    options
  );

export default useAddRoomImagesMutation;
